import { getSalesAgentInfo } from 'merchant-api/spiceroad';
import { FormattedMessage } from 'react-intl';
import { formatPhone } from '@odmonorepo/odfunctions';
import { DefaultErrorPage } from '@odmonorepo/core-components';

// Generic "contact OnDeck" screen, shown regardless of partner channel or application type.
export const ContactUs = () => {
  const { salesAgentInfo, isSalesAgentInfoLoading } = getSalesAgentInfo();
  if (isSalesAgentInfoLoading) return null;

  const contactName = salesAgentInfo?.name ? salesAgentInfo.name : undefined;
  const phoneLink = salesAgentInfo?.phone ? 'tel:+1' + salesAgentInfo.phone : undefined;
  const callButton = salesAgentInfo?.phone ? 'Call ' + formatPhone(salesAgentInfo.phone) : undefined;

  return (
    <DefaultErrorPage
      title={<FormattedMessage id="customError.contactUs.title" />}
      message={<FormattedMessage id="customError.contactUs.message" />}
      contactName={contactName}
      contactDescription={salesAgentInfo?.name ? 'Loan Advisor' : undefined}
      link={phoneLink}
      CTA={callButton}
      hasHeader={true}
    />
  );
}

export default ContactUs;
